import * as React from "react";
import {FilingLocation, DmsSearch, MetadataFields} from "../models";
import {Spinner, SpinnerSize} from "office-ui-fabric-react/lib/Spinner";
import {Icon} from "office-ui-fabric-react/lib/Icon";
import {IconNames} from "office-ui-fabric-react/lib/Icons";
import "./LocationItem.css";
import {post} from "../api";
import {PrimaryButton} from "office-ui-fabric-react";
import * as microsoftTeams from "@microsoft/teams-js";
import GetIcons from "./GetIcons";
import {BrowseDocumentsContext} from "./components/BrowseDmsDocuments";

export interface LocationItemProps {
    Location: FilingLocation;
    Expanded: (parent: FilingLocation, children: FilingLocation[]) => void;
    FileTo: (onComplete: () => void) => void;
    localDocs: boolean;
    teamsId: string;
    channelId: string;
    storageType: string;
    UserId: string;
    tenantId: string;
    isDarkMode: boolean;
}

export interface LocationItemState {
    Expanding: boolean;
    Expanded: boolean;
    Filing: boolean;
    InDms: boolean;
    InTeams: boolean;
    Metadata: MetadataFields;
    IsSaving: boolean;
    dmsSearch: DmsSearch;
}

export default class LocationItem extends React.Component<LocationItemProps, LocationItemState> {
    context!: React.ContextType<typeof BrowseDocumentsContext>;

    constructor(props: LocationItemProps, context: React.ContextType<typeof BrowseDocumentsContext>) {
        super(props, context);
        this.state = {
            Expanding: false,
            Expanded: false,
            Filing: false,
            InDms: this.props.Location.Metadata["InDMS"] == "Yes" ? true : false,
            InTeams:
                this.props.Location.Metadata["InTeams"] == "Yes" ||
                this.props.Location["InTeams"] == "Yes (Changed Locally)"
                    ? true
                    : false,
            Metadata: this.props.Location.Metadata,
            IsSaving: false,
            dmsSearch: {
                CaseName: "",
                CaseSearched: false,
                DocName: "",
                DocSearched: false,
                TeamsUrl: "",
                Url: "",
                Metadata: {},
                InitialId: "",
                StorageType: "",
                DeletedFile: false,
                Linked: true,
                ShowStatus: false,
                TeamsDocumentStatus: false,
                IsUploading: false,
            },
        };
    }

    public async componentWillMount(): Promise<void> {
        microsoftTeams.initialize();
    }

    fileLocation = () => {
        this.props.FileTo(() => {});

        this.setState({
            Filing: true,
        });
        setTimeout(() => {
            this.setState({Filing: false});
        }, 15000);
    };

    private expand = () => {
        this.setState({
            Expanding: true,
        });

        this.context.browseDms({
            Path: this.props.Location.Url,
            ContentLocationId: this.props.Location.ContentLocationId,
            Metadata: this.props.Location.Metadata,
            StorageType: this.props.Location.StorageType,
            RootUrl: this.props.Location.SiteUrl,
            TeamsId: this.props.teamsId,
            TenantId: this.props.tenantId,
            UserId: this.props.UserId,
            ChannelId: this.props.channelId,
            NextPage: null,
            SortProperties: null,
            handleResult: (r) => {
                this.setState({
                    Expanding: false,
                    Expanded: true,
                });
                const children = r as FilingLocation[];
                for (const child of children) {
                    child.IsChildLocation = true;
                }

                this.props.Expanded(this.props.Location, children);
            },
            handleError: (_) => {
                this.setState({
                    Expanding: false,
                    Expanded: false,
                });
            },
            RefreshingView: false,
        });
    };

    showSaveButton() {
        this.state.Metadata["InDMS"] == "No" && this.state.Metadata["InTeams"] == "Yes (Changed Locally)"
            ? true
            : false;
    }

    showCheckoutButton() {
        this.state.Metadata["InDMS"] == "Yes" && this.state.Metadata["InTeams"] == "No" ? true : false;
    }

    saveToDms() {
        this.setState({IsSaving: true});

        post("/api/teamsdmsintegration/SaveFileToDms", {
            Url: this.props.Location.Url,
            Metadata: this.state.Metadata,
            TeamsId: this.props.teamsId,
            ChannelId: this.props.channelId,
            UseServiceAppToken: false,
            UserId: this.props.UserId,
            TenantId: this.props.tenantId,
        }).then((_r) => {
            const metadata = this.props.Location.Metadata;
            if (metadata["InDMS"] == "No") {
                metadata["InDMS"] = "Yes";
            } else if (metadata["InTeams"] == "Yes (Changed Locally)") {
                metadata["InTeams"] = "Yes";
            }
            this.setState({
                Metadata: metadata,
                IsSaving: false,
            });
        });
    }

    selectDoc() {
        const dmsSearch = this.state.dmsSearch;
        if (this.props.Location.Metadata["InTeams"] == "No (Deleted Recently)") {
            dmsSearch.DeletedFile = true;
        } else {
            dmsSearch.TeamsDocumentStatus = true;
        }

        dmsSearch.DocName = this.props.Location.Name;
        dmsSearch.TeamsUrl = this.props.Location.Metadata["TeamsUrl"];
        dmsSearch.Url = this.props.Location.Url;
        dmsSearch.Metadata = this.props.Location.Metadata;
        dmsSearch.StorageType = this.props.storageType;
        dmsSearch.ShowStatus = true;
        microsoftTeams.tasks.submitTask(dmsSearch, undefined);

        return Promise.resolve();
    }

    render() {
        const iconDetails = GetIcons.getIconName(
            this.props.Location.Name,
            this.props.isDarkMode,
            this.props.Location.Metadata,
            this.props.Location.IsFile
        );

        return (
            <div className="suggestion-itemcontainer" style={{position: "relative", border: "10px"}}>
                {this.props.Location.Percent > 0 && (
                    <div style={{width: "30px", float: "right"}} className="confidenceLevel">
                        {this.props.Location.Percent} %
                        <img
                            style={{height: "16px", width: this.props.Location.Percent.toString() + "%"}}
                            src="../../Content/heatbar8.png"
                        />
                    </div>
                )}

                <div className="search-result-container">
                    <div
                        className="search-result-details"
                        title={this.props.Location.CanFileDirect ? "Checkout file to teams" : ""}
                        onClick={this.props.Location.CanFileDirect && !this.props.localDocs ? this.fileLocation : null}
                        style={{cursor: this.props.Location.CanFileDirect ? "pointer" : "default"}}
                    >
                        {this.props.Location.IsFile && (
                            <Icon
                                iconName={iconDetails[0]}
                                style={{fontSize: "18px", marginRight: "5px", color: iconDetails[1]}}
                            />
                        )}
                        {this.props.Location.Name}
                        {this.props.Location.Metadata["CheckedOut"] == "true" && (
                            <Icon
                                title="This file is checked out"
                                style={{float: "right"}}
                                iconName={IconNames.CheckedOutByOther12}
                            />
                        )}
                        {this.props.localDocs && (
                            <span style={{position: "absolute", left: "50%"}}>{this.state.Metadata["InTeams"]}</span>
                        )}
                        {this.props.localDocs && (
                            <span style={{position: "absolute", left: "67%"}}>{this.state.Metadata["InDMS"]}</span>
                        )}
                        {(this.state.Metadata["InDMS"] !== undefined || this.state.Metadata["InTeams"] !== undefined) &&
                            !this.state.IsSaving && (
                                <PrimaryButton
                                    style={{float: "right", width: "125px"}}
                                    onClick={() => this.selectDoc()}
                                    text={"Show Status"}
                                />
                            )}
                        {this.props.localDocs && this.state.IsSaving && (
                            <Spinner style={{float: "right", paddingRight: "62.5px"}} size={SpinnerSize.medium} />
                        )}
                        <div
                            className="search-result-url"
                            style={{
                                color: !this.props.Location.CanFileDirect ? "darkgray" : "#007bff",
                                maxWidth: this.props.localDocs ? "45%" : "",
                            }}
                        >
                            {this.props.Location.Path}
                        </div>
                    </div>

                    <div className="search-result-actions">
                        {this.props.Location.ContentLocationIsExpandable && !this.state.Expanding && (
                            <div
                                onClick={this.expand}
                                title="Expand location"
                                style={{cursor: "pointer", height: "100%"}}
                            >
                                <Icon iconName={IconNames.ChevronRight} style={{fontSize: "18px"}} />
                            </div>
                        )}

                        {this.state.Expanding && <Spinner size={SpinnerSize.medium} />}
                    </div>
                </div>

                {this.state.Filing && (
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "rgba(232, 234, 237, 0.5)",
                        }}
                    >
                        <Spinner size={SpinnerSize.medium} style={{position: "relative", top: "10px"}} />
                    </div>
                )}
            </div>
        );
    }
}
LocationItem.contextType = BrowseDocumentsContext;
